import { SelectedClicksRadiusState } from "slices/selectedOptions/selectedClicksRadiusSlice";
import { SelectedClicksState } from "slices/selectedOptions/selectedClicksSlice";
import { SelectedClusteringState } from "slices/selectedOptions/selectedClusteringSlice";
import { SelectedFilterQuestionState } from "slices/selectedOptions/selectedFilterQuestionSlice";
import { SelectedImageState } from "slices/selectedOptions/selectedImageSlice";
import { SelectedQuestionsState } from "slices/selectedOptions/selectedQuestionsSlice";
import { SelectedTransparencyState } from "slices/selectedOptions/selectedTransparencySlice";
import { SelectedWeightingVariableState } from "slices/selectedOptions/selectedWeightingVariableSlice";
import { LoadingState } from "types/loadingState";

export type ProjectHeatmapSettings = {
  selectedClicksRadius?: SelectedClicksRadiusState;
  selectedTransparency?: SelectedTransparencyState;
  selectedClicks?: SelectedClicksState;
  selectedClustering?: SelectedClusteringState;
  selectedFilterQuestion?: SelectedFilterQuestionState;
  selectedImage?: SelectedImageState;
  selectedQuestions?: SelectedQuestionsState;
  selectedWeightingVariable?: SelectedWeightingVariableState;
};

export interface ProjectHeatmapSettingsState {
  currentProjectSettings: ProjectHeatmapSettings;
  loading: LoadingState;
  updateLoading: LoadingState;
};

export const initialProjectHeatmapSettingsState: ProjectHeatmapSettingsState = {
  loading: LoadingState.idle,
  updateLoading: LoadingState.idle,
  currentProjectSettings: {},
};
